import React from "react";
import { gql, useQuery } from "@apollo/client";
import { RouteComponentProps } from "@reach/router";
import { MainLayout } from "pages/Layouts";
import { getForm } from "types/gql-types";
import { LoadingSpinner } from "components/graphql-views";
import { LoneGrid } from "components/login/components/shared-components";
import { humanizeFormType } from "utils/form-types";
import FormClosedLayout from "pages/eligibility/components/form/form-closed";
import Authenticated from "./authenticated";

const GET_FORM = gql`
  query getForm($formId: ID!) {
    form(id: $formId) {
      type
      open
      
      property {
        name
        organization {
          name
        }
      }
    }
  }
`;

const FormLayout: React.FC<RouteComponentProps<{ formId?: string, path?: string}>> =
({ formId = "", path }) => {
  const isSignup = path?.includes("/signup");

  const { loading, data: response } =
    useQuery<getForm>(GET_FORM, { fetchPolicy: "no-cache", variables: { formId } });
  if (loading) return <LoadingSpinner />;
  if (!response || !response.form.property || !response.form.property.organization) return null;
  if (!response.form.open) {
    return <FormClosedLayout
      propertyName={response.form.property.name}
      formType={response.form.type}
    />;
  }

  return (<MainLayout backgroundColor="white" showHeader showFooter>
    <LoneGrid>
      <Authenticated formId={formId || ""} isSignup={isSignup}
        formType={humanizeFormType(response.form.type)}
        propertyName={response.form.property.name} />
    </LoneGrid>
  </MainLayout>);
};

export default FormLayout;
